import * as types from "./actionTypes";

export const fetchSearch = query => ({
  type: types.FETCH_SEARCH,
  query
});

export const fetchSearchSuccess = result => ({
  type: types.FETCH_SEARCH_SUCCESS,
  result
});

export const fetchSearchError = error => ({
  type: types.FETCH_SEARCH_FAIL,
  error
});

export const queryUpdate = query => ({
  type: types.QUERY_UPDATE,
  query
});

export const fetchNextPage = () => ({
  type: types.FETCH_NEXT_PAGE
});

export const fetchNextPageSuccess = result => ({
  type: types.FETCH_NEXT_PAGE_SUCCESS,
  result
});

export const fetchSearchFinish = () => ({
  type: types.FETCH_SEARCH_FINISH
});

export const clearSearch = () => ({
  type: types.CLEAR_SEARCH
});



// WEBPACK FOOTER //
// ./src/modules/search/actions.js